import { Button } from '@/components/ui/button'
import { Globe, Users, User, LucideIcon } from 'lucide-react'

interface ScopeItem {
  id: string
  label: string
  icon: LucideIcon
}

const scopes: ScopeItem[] = [
  { id: 'all', label: 'All', icon: Globe },
  { id: 'friends', label: 'Friends', icon: Users },
  { id: 'me', label: 'Mine', icon: User },
]

interface ScopePickerProps {
  activeScope?: string
  homeBaseName?: string
  onScopeChange?: (scope: string) => void
}

export function ScopePicker({ activeScope = 'all', homeBaseName, onScopeChange }: ScopePickerProps) {
  return (
    <div className="flex items-center gap-1.5 px-4 md:px-6 lg:px-8 min-w-0">
      {/* Other Homes button */}
      <Button
        variant="outline"
        size="sm"
        className="shrink-0 rounded-full text-xs h-8 px-2.5 gap-1 border-dashed"
      >
        <Globe className="w-3 h-3" />
        <span className="hidden xs:inline">Other Homes</span>
      </Button>

      {/* Segmented control */}
      <div className="flex-1 min-w-0 flex bg-muted rounded-lg p-0.5">
        {scopes.map((scope) => {
          const isActive = activeScope === scope.id
          const label = scope.id === 'all' && homeBaseName ? homeBaseName : scope.label
          return (
            <button
              key={scope.id}
              onClick={() => onScopeChange?.(scope.id)}
              className={`
                flex-1 min-w-0 flex items-center justify-center gap-1 py-2 px-2 sm:px-3 rounded-md text-xs font-semibold
                transition-all duration-200
                ${isActive
                  ? 'bg-background text-foreground shadow-sm'
                  : 'text-muted-foreground hover:text-foreground'
                }
              `}
            >
              <scope.icon className="w-3.5 h-3.5" />
              {label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
